const btnClearFilterManagementService = {
  Typography: 'Limpar'
};

export default btnClearFilterManagementService;
